import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=eedc0ea4&scoped=true&"
import script from "./PageBase.vue?vue&type=script&lang=ts&"
export * from "./PageBase.vue?vue&type=script&lang=ts&"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=eedc0ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedc0ea4",
  null
  
)

export default component.exports